/* eslint-disable @typescript-eslint/no-var-requires */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck Using `$hasDep()` means that react-dnd@<5 types are not available.

export const DragComponent = $hasDep('react-dnd', '5') ? require('../v5/DragComponent').DragComponent : require('../ltV5/DragComponent').DragComponent;
export const DropComponent = $hasDep('react-dnd', '5') ? require('../v5/DropComponent').DropComponent : require('../ltV5/DropTargetWrapper').DropTargetWrapper;